import { z } from "zod";

// Schema para notificaciones
export const notificationSettingsSchema = z.object({
  email: z.boolean().default(true),
  push: z.boolean().default(false),
  weekly: z.boolean().default(true),
  marketing: z.boolean().default(false),
});

// Schema para apariencia
export const appearanceSettingsSchema = z.object({
  theme: z.enum(["light", "dark", "auto"]).default("light"),
  language: z.enum(["es", "en", "pt"]).default("es"),
  timezone: z.string().default("UTC-5"),
  compactMode: z.boolean().default(false),
});

// Schema para seguridad
export const securitySettingsSchema = z.object({
  twoFactorEnabled: z.boolean().default(false),
  sessionTimeout: z.number().min(5).max(1440).default(30), // minutos
  passwordExpiryDays: z.number().min(30).max(365).default(90),
  loginAttempts: z.number().min(3).max(10).default(5),
});

// Schema para configuración del sistema
export const systemSettingsSchema = z.object({
  maintenanceMode: z.boolean().default(false),
  debugMode: z.boolean().default(false),
  logLevel: z.enum(["error", "warn", "info", "debug"]).default("info"),
  backupFrequency: z.enum(["daily", "weekly", "monthly"]).default("daily"),
});

// Schema principal de configuración
export const settingsSchema = z.object({
  notifications: notificationSettingsSchema,
  appearance: appearanceSettingsSchema,
  security: securitySettingsSchema,
  system: systemSettingsSchema,
});

// Schema para actualizar configuración
export const updateSettingsSchema = settingsSchema.partial();

// Tipos inferidos de los schemas
export type NotificationSettings = z.infer<typeof notificationSettingsSchema>;
export type AppearanceSettings = z.infer<typeof appearanceSettingsSchema>;
export type SecuritySettings = z.infer<typeof securitySettingsSchema>;
export type SystemSettings = z.infer<typeof systemSettingsSchema>;
export type Settings = z.infer<typeof settingsSchema>;
export type UpdateSettingsData = z.infer<typeof updateSettingsSchema>;
